import { cn } from '@lib/utils';

interface DescriptionProps extends React.HTMLAttributes<HTMLDivElement> {
  description: React.ReactNode;
}

export default function Description({
  description,
  className,
  ...rest
}: DescriptionProps) {
  const baseClassName =
    'whitespace-pre-line font-semibold text-lg leading-7 tracking-[-0.256px] md:text-2xl md:leading-8 md:tracking-[-0.464px]';

  return (
    <div {...rest} className={cn(baseClassName, className)}>
      {description}
    </div>
  );
}
